<template>
    <div class="card">
        <div class="card-header bg-white">
            <h5 class="me-auto">{{ title }}</h5>
        </div>
        <div class="card-body p-0">
            <template>
                <v-data-table class="elevation-1 table-sm" 
                    :headers="headers"
                    :items="data"
                    hide-default-footer
                    dense
                    :item-class="BACKGROUND"
                    :items-per-page="-1">
                    <template v-slot:[`item.id`]="{ item }">
                        {{ item.type }}{{ item.id }}
                    </template>
                    <template v-slot:[`item.pieces`]="{ item }">
                        {{ Number(item.pieces || 0).toFixed(2) }}
                    </template>
                    <template v-slot:[`item.description`]="{ item }">
                        <v-tooltip bottom class="mx-1">
                            <template v-slot:activator="{ on, attrs }">
                                <div v-bind="attrs" v-on="on" class="nowrap" v-if="Array.isArray(item.description)">
                                    {{ item.description[0] }} ...
                                </div>
                            </template>
                            <small><div v-for="(description, key) in  item.description" :key="key">{{ description }}</div></small>
                        </v-tooltip>
                    </template>
                    <template v-slot:[`item.lengthy`]="{ item }">
                        {{ Number(item.lengthy || 0).toFixed(2) }}
                    </template>
                    <template v-slot:[`item.width`]="{ item }">
                        {{ Number(item.width || 0).toFixed(2) }}
                    </template>
                    <template v-slot:[`item.tall`]="{ item }">
                        {{ Number(item.tall || 0).toFixed(2) }}
                    </template>
                    <template v-slot:[`item.weight`]="{ item }">
                        {{ Number(item.weight || 0).toFixed(2) }}
                    </template>
                    <template v-slot:[`item.volumetric_weight`]="{ item }">
                        {{ Number(item.volumetric_weight || 0).toFixed(2) }}
                    </template>
                </v-data-table>
            </template>
        </div>
    </div>
</template>
<script>
export default{
    props: ['data', 'title'],
    data(){
        return{
            headers: [
                { text: 'GVT', value: 'id', sortable: false },
                { text: 'Tienda', value: 'shipper', sortable: false },
                { text: 'Consignatario', value: 'user.name', sortable: false },
                { text: 'Piezas', value: 'pieces', sortable: false },
                { text: 'Empacado', value: 'packing.name', sortable: false },
                { text: 'Descripción', value: 'description', sortable: false },
                { text: 'La.', value: 'lengthy', sortable: false },
                { text: 'An.', value: 'width', sortable: false },
                { text: 'Al.', value: 'tall', sortable: false },
                { text: 'Peso', value: 'weight', sortable: false },
                { text: 'Vol.', value: 'volumetric_weight', sortable: false },
                { text: 'Transportista', value: 'carrier.name', sortable: false },
                { text: 'No. Tracking', value: 'tracking', sortable: false }
            ],
        }
    },
    methods: {
        BACKGROUND: function (item){
            if(item.job == 1){
                return 'bg-secondary'
            }else if(item.job == 2){
                return 'bg-danger'
            }else {
                if(item.state_id >= 4){
                    return item.masived_at ? 'bg-primary' : 'yellow'
                }
            }

            return ''
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/pages/awbs/table/TableScan.vue